import React from "react"
import { TourProps } from "antd"

export const IDs = {
    botaoSalvar: "cadastro-plano-contas-botao-salvar",
    campoDescricao: "cadastro-plano-contas-campo-descricao",
    campoCodigoContabil: "cadastro-plano-contas-campo-codigo-contabil",
    campoEmpresa: "cadastro-plano-contas-campo-empresa",
    campoGrupo: "cadastro-plano-contas-campo-grupo",
    campoSubgrupo: "cadastro-plano-contas-campo-subgrupo",
    campoTipo: "cadastro-plano-contas-campo-tipo",
    campoClassificacao: "cadastro-plano-contas-campo-tipo-registro",
    formularioDeCentroDeCusto: "cadastro-plano-contas-formulario-centro-custo",
    botaoAjudaDoCentroDeCusto: "cadastro-plano-contas-formulario-centro-custo-ajuda",
    botaoIncluirDoCentroDeCusto: "cadastro-plano-contas-formulario-centro-custo-botao-incluir",
    campoCentroDeCustoDoCentroDeCusto: "cadastro-plano-contas-formulario-centro-custo-centro-custo",
    campoProporcaoDoCentroDeCusto: "cadastro-plano-contas-formulario-centro-custo-proporcao",
}

export const Classes = {
    botaoExcluirDoCentroDeCusto: "cadastro-plano-contas-formulario-centro-custo-btn-excluir"
}

export const AdicionarProporcoes: TourProps["steps"] = [
    {
        title: "Painel de proporções",
        description: "O painel é utilizado para cadastrar os centros de custos do plano de contas.",
        target: () => document.getElementById(IDs.formularioDeCentroDeCusto)!,
    },
    {
        title: "Adição de um novo registro",
        description: <>
            Selecione o centro de custo que deve se relacionar à proporção. <br/>
            Os centros de custo listados são todos os registros que compartilham a mesma empresa que foi selecionada no formulário acima. 
        </>,
        target: () => document.getElementById(IDs.campoCentroDeCustoDoCentroDeCusto)!,
    },
    {
        title: "Proporção",
        description: "Insira o valor da proporção (%).",
        target: () => document.getElementById(IDs.campoProporcaoDoCentroDeCusto)!,
    },
    {
        title: "Incluir",
        target: () => document.getElementById(IDs.botaoIncluirDoCentroDeCusto)!,
        description: <>
            Para finalizar o registro, clique em incluir. <br/>
            Lembre-se que a soma do valor total não pode exceder 100%, portanto certifique-se que o novo valor esteja dentro dos limites permitidos.
        </>
    },
    {
        title: "Excluir",
        target: () => document.querySelector(`.${Classes.botaoExcluirDoCentroDeCusto}`)!,
        description: `Caso desejar, você pode remover um registro apertando sobre o botão "Excluir".`
    }
]

export const AdicionarGrupo: TourProps["steps"] = [
    {
        description: "Selecione a empresa.",
        target: () => document.getElementById(IDs.campoEmpresa)!,
    },
    {
        description: "Selecione o tipo.",
        target: () => document.getElementById(IDs.campoTipo)!,
    },
    {
        description: `Adicione sua descrição.`,
        target: () => document.getElementById(IDs.campoDescricao)!,
    },
    {
        description: `Especifique o código contábil (opcional).`,
        target: () => document.getElementById(IDs.campoCodigoContabil)!,
    },
    {
        description: `Clique em "Salvar".`,
        target: () => document.getElementById(IDs.botaoSalvar)!,
    }
].map((v, i) => ({ title: `Passo ${i + 1}`, ...v  })) as TourProps["steps"]

export const AdicionarSubGrupo: TourProps["steps"] = [
    {
        description: "Selecione a empresa.",
        target: () => document.getElementById(IDs.campoEmpresa)!,
    },
    {
        description: "Selecione o tipo.",
        target: () => document.getElementById(IDs.campoTipo)!,
    },
    {
        description: `Dê um nome ao subgrupo.`,
        target: () => document.getElementById(IDs.campoDescricao)!,
    },
    {
        description: `Especifique o código contábil (opcional).`,
        target: () => document.getElementById(IDs.campoCodigoContabil)!,
    },
    {
        description: "Selecione o grupo.",
        target: () => document.getElementById(IDs.campoGrupo)!,
    },
    {
        description: `Clique em "Salvar".`,
        target: () => document.getElementById(IDs.botaoSalvar)!,
    },
].map((v, i) => ({ title: `Passo ${i + 1}`, ...v })) as TourProps["steps"]

export const AdicionarItem: TourProps["steps"] = [
    {
        description: "Selecione a empresa.",
        target: () => document.getElementById(IDs.campoEmpresa)!,
    },
    {
        description: "Selecione o tipo.",
        target: () => document.getElementById(IDs.campoTipo)!,
    },
    {
        description: "Dê um nome ao item.",
        target: () => document.getElementById(IDs.campoDescricao)!,
    },
    {
        description: `Especifique o código contábil (opcional).`,
        target: () => document.getElementById(IDs.campoCodigoContabil)!,
    },
    {
        description: "Selecione o grupo.",
        target: () => document.getElementById(IDs.campoGrupo)!,
    },
    {
        description: "Selecione o subgrupo.",
        target: () => document.getElementById(IDs.campoSubgrupo)!,
    },
    {
        title: "Proporções.",
        description: "Cadastre as proporções do item.",
        target: () => document.getElementById(IDs.formularioDeCentroDeCusto)!,
    },
    {
        title: "Mais detalhes do cadastro de proporções.",
        description: "Para um tutorial mais específico quanto ao cadastro de proporções, clique no ícone.",
        target: () => document.getElementById(IDs.botaoAjudaDoCentroDeCusto)!,
    },
    {
        title: "Persistência",
        description: `Para gravar suas alterações, clique em "Salvar".`,
        target: () => document.getElementById(IDs.botaoSalvar)!,
    },
].map((v, i) => ({ title: `Passo ${i + 1}`, ...v })) as TourProps["steps"]

